import Text from "@/components/Text";
import classes from "./index.module.css";
import { ReactNode } from "react";
import { sanitize } from "isomorphic-dompurify";

interface DescriptionProps {
  description: ReactNode | undefined;
}

export const ModalDescription = ({ description }: DescriptionProps) => {
  return (
    description &&
    (typeof description === "string" ? (
      <Text variant="reading_medium" className={classes.description}>
        <span
          dangerouslySetInnerHTML={{
            __html: sanitize(description),
          }}
        />
      </Text>
    ) : (
      description
    ))
  );
};
